/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file

==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

import { defaultAxios, cachedAxios } from './services/http'
Vue.prototype.$http = defaultAxios
Vue.prototype.$httpCached = cachedAxios

// Vuexy Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// ACL
import acl from './acl/acl'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

//Recaptcha V3
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
  siteKey: '6LerzxQaAAAAAHPNsKjCDjSctG3sYXJk0dtYyXYT',
  loaderOptions: {
    autoHideBadge: true
  }
})

// Styles: SCSS
import './assets/scss/main.scss'

//Load Script
import LoadScript from 'vue-plugin-load-script'
Vue.use(LoadScript)

// Loading Skeleton
import Skeleton from 'vue-loading-skeleton'
Vue.use(Skeleton)

// Tailwind
import '@/assets/css/main.css'

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Vue Router
import router from './router'

//Vue Debounce
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

//Vue Transitions
import Transitions from 'vue2-transitions'
Vue.use(Transitions)

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

//Vue Movable
import movable from 'v-movable'
Vue.use(movable)

//Confetti
import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)

//Fullscreen
import VueFullscreen from 'vue-fullscreen'
Vue.use(VueFullscreen)

//Draggable
import VueShopifyDraggable from 'vue-shopify-draggable'
Vue.use(VueShopifyDraggable)

// CryptoJS
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Image Viewer
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999999999999999
  }
})

// Moment
import VueMoment from 'vue-moment'
Vue.use(VueMoment)

// Vue Plyr
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

// Userback
//import UserbackPlugin from '@userback/vue2';
//Vue.use(UserbackPlugin, { token: '40270|80585|sO2OtcRgmahSY214eA6fGCgWh' });

// Feather font icon
import './assets/css/iconfont.css'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

//import { dom } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'

import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'

library.add(fas)
library.add(far)

//dom.watch()
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue Idle Hook
import IdleVue from 'idle-vue'
const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 60000
})

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^stream/]

new Vue({
  router,
  store,
  acl,
  render: (h) => h(App)
}).$mount('#app')
